<script setup>
import Label from '../Support/Label'
import { onBeforeMount, onMounted, ref, watch } from 'vue'
import { useBreadStore } from '@bread/js/store'

const emits = defineEmits(['change'])
const props = defineProps({
  filter: {
    type: Object,
    required: true,
  },
})

const store = useBreadStore()
const value = ref(null)
let mounted = false


onBeforeMount(() => {
  value.value = props.filter.value
})

onMounted(() => {
  mounted = true
})

watch(value, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    store.setFilterValue(props.filter.uuid, newValue)
    if (mounted) {
      emits('change')
    }
  }
})
</script>

<template>
  <Label>{{ props.filter.label }}</Label>
  <input
    type="text"
    v-model="value"
    class="w-96 rounded-sm border-gray-200 text-sm"
  />
</template>
